document.addEventListener('DOMContentLoaded', function () {
  // Find any product forms on the page
  var forms = document.querySelectorAll('form.product-form, form[action*="/cart/add"]');

  forms.forEach(function (form) {
    var checkbox = form.querySelector('.delivery-terms-confirm__checkbox');
    if (!checkbox) return; // form doesn't use delivery terms

    // Guard on form submit (covers most cases)
    form.addEventListener('submit', function (e) {
      if (!checkbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation && e.stopImmediatePropagation();
        alert('Please confirm you have read and understood our Delivery Terms before adding this tank to your cart.');
      }
    });

    // Extra guard on the Add to cart button click (for apps that bypass submit)
    var submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitButton) {
      submitButton.addEventListener('click', function (e) {
        if (!checkbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          alert('Please confirm you have read and understood our Delivery Terms before adding this tank to your cart.');
        }
      });
    }
  });
});
